(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["footer-localization"] && !Shopify.designMode) return;
  try {
    const formatReferenceCurrency = (countryName, currencyCode) => {
    let symbol = '';

    try {
      const currencyPart = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
        style: 'currency',
        currency: currencyCode,
        currencyDisplay: 'narrowSymbol',
      })
        .formatToParts(0)
        .find((part) => part.type === 'currency');

      if (currencyPart && currencyPart.value !== currencyCode) {
        symbol = currencyPart.value;
      }
    } catch (_error) {
      symbol = '';
    }

    return symbol ? `${countryName} (${currencyCode} ${symbol})` : `${countryName} (${currencyCode})`;
  };

  const updateFooterReferenceCurrencies = (root = document) => {
    root.querySelectorAll('.footer-localization__select option[data-local-currency-code]').forEach((option) => {
      option.textContent = formatReferenceCurrency(option.dataset.countryName, option.dataset.localCurrencyCode);
    });

    root.querySelectorAll('[data-footer-current-currency]').forEach((element) => {
      element.textContent = formatReferenceCurrency(element.dataset.countryName, element.dataset.localCurrencyCode);
    });
  };

  updateFooterReferenceCurrencies();
  document.addEventListener('shopify:section:load', (event) => updateFooterReferenceCurrencies(event.target));
  } catch(e) { console.error(e); }
})();

})();
